import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const normalize = (value) => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export function ProcessSupplierPicker({ suppliers, value, fallback, onSelect, disabled, label = "Proveedor", compact = false }) {
  const [open, setOpen] = React.useState(false);
  const [query, setQuery] = React.useState("");
  const selected = suppliers.find((supplier) => supplier.id === value);
  const terms = normalize(query).trim().split(/\s+/).filter(Boolean);
  const matches = suppliers.filter((supplier) => terms.every((term) => normalize(`${supplier.erp_code} ${supplier.name}`).includes(term)));
  const choose = (supplier) => { onSelect(supplier); setOpen(false); };
  return <Popover open={open} onOpenChange={(next) => { setOpen(next); if (next) setQuery(""); }}>
    <PopoverTrigger asChild><Button variant="outline" type="button" disabled={disabled} aria-label={label} title={selected ? `${selected.erp_code} · ${selected.name}` : fallback || "Buscar proveedor…"}
      className={compact ? "h-8 min-w-0 w-full justify-start px-2 text-xs" : "h-auto min-h-10 w-full whitespace-normal text-left justify-start"}>
      <span className={compact ? "truncate" : ""}>{selected ? `${selected.erp_code} · ${selected.name}` : fallback || "Buscar proveedor…"}</span>
    </Button></PopoverTrigger>
    <PopoverContent className="w-80 p-2" align="start">
      <Input aria-label={`Buscar ${label.toLowerCase()}`} placeholder="Nombre o código del proveedor" value={query} onChange={(event) => setQuery(event.target.value)}
        onKeyDown={(event) => { if (event.key === "Enter" && matches.length === 1) { event.preventDefault(); choose(matches[0]); } }} />
      <div className="mt-2 max-h-60 overflow-y-auto">
        <button type="button" className="block w-full p-2 text-left text-muted-foreground hover:bg-accent" onClick={() => choose(null)}>Sin asignar</button>
        {matches.map((supplier) => <button key={supplier.id} type="button" className="block w-full rounded p-2 text-left text-sm hover:bg-accent focus:bg-accent" onClick={() => choose(supplier)}>{supplier.erp_code} · {supplier.name}</button>)}
        {!matches.length && <p className="p-2 text-sm text-muted-foreground">No hay proveedores que coincidan.</p>}
      </div>
    </PopoverContent>
  </Popover>;
}
